<template>
  <v-layout column>
    <v-flex class="pb-16">
      <text-field
        id="loginEmail"
        v-model.trim="form.email"
        :validator="vs.form.email"
        :label="$t('loginFormEmail', 'Email*')"
        type="email"
        autofocus
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        id="loginPassword"
        v-model.trim="form.password"
        :validator="vs.form.password"
        :label="$t('loginFormPassword', 'Password*')"
        :type="showPasswordInput ? 'text' : 'password'"
        :append-icon="showPasswordInput ? 'visibility_off' : 'visibility'"
        @clickAppendIcon="showPasswordInput = !showPasswordInput"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'login-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showPasswordInput: false,
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped></style>
